import Headers from "@/component/Headers";
import PopupFrame from "@/component/popups/ui-1";
import backgroundHeaderHistory from "@assets/web-v3-images/background-Header-History.png";
import passwordResetImg from "@assets/web-v3-images/icon-success.png";
import failedImg from "@assets/web-v3-images/something-went-wrong.png";
import btnImg from "@assets/web-v3-images/btn-acc.png";
import { EyeClosedIcon, EyeOpenIcon } from "@radix-ui/react-icons";
import { Text } from "@radix-ui/themes";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import OTPInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {
  getCurrentUser,
  requestOtp,
  updatePassword,
  verifyOtpPassword,
} from "../Redux/futures/account/actions";
import { curStateAccount } from "../Redux/selector";
import PATH from "../config/PATH";
import UseResponsive from "@/utils/hooks/useResponsive";
import Countdown from '@/component/Countdown';

const PasswordInput = ({ label, placeholder, onChange, value }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="flex flex-col gap-3">
      <label className="text-[27px] font-semibold text-[rgba(113,59,18,1)] pt-6">
        {label}
      </label>
      <div className="relative">
        <input
          type={show ? "text" : "password"}
          placeholder={placeholder}
          onChange={onChange}
          value={value}
          autoComplete="new-password"
          className={`
						 w-full
            h-[80px]
            rounded-[24px]
            border
            border-[#FF8D3A]
            bg-[#F9D7A4]
            px-8
            pr-20
						text-[25px]
            text-[#7A4515]
            outline-none
            focus:ring-2
            focus:ring-[#FF8D3A]
					${show ? "text-[rgba(202,133,4,1)]" : "text-[rgba(113,59,18,1)]"}
						`}
        />
        <button
          type="button"
          onClick={() => setShow(!show)}
          className="absolute right-6 top-1/2 -translate-y-1/2"
        >
          {show ? (
            <EyeOpenIcon className="w-8 h-8 text-[#9C5A1A]" />
          ) : (
            <EyeClosedIcon className="w-8 h-8 text-[#9C5A1A]" />
          )}
        </button>
      </div>
    </div>
  );
};

const Buttons = ({ handleClick, textBtn, classItem, classbuttom }) => {
  return (
    <button
      className={`relative w-full cursor-pointer btn-click-active max-w-[100%] mt-[4%] outline-none ${classItem}`}
      onClick={handleClick}
    >
      <img src={btnImg} className="block w-full h-full" alt="Revive" />

      <Text
        className={`absolute inset-0 flex items-center justify-center text-[29px] font-extrabold text-white ${classbuttom}`}
        style={{
          WebkitTextStroke: "1px #FF692E",
          paintOrder: "stroke fill",
        }}
      >
        {textBtn}
      </Text>
    </button>
  );
};

function ChangePassword() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectorAccount = useSelector(curStateAccount);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [openCount, setOpenCount] = useState(false);
  const [countdown, setCountdown] = useState(180);
  const [stateNotifycation, setStateNotifycation] = useState({
    open: false,
    title: "",
    content: "",
  });
  const [openModalConfirm, setOpenModalConfirm] = useState(false);
  // Đang verify OTP / đổi mật khẩu -> chặn gọi API lặp (auto-submit khi đủ 6 số
  // + bấm Confirm, hoặc onChange bắn nhiều lần khi dán mã).
  const verifyingRef = useRef(false);

  const [statusInput, setStatusInput] = useState({
    confirmPassword: "",
    password: "",
  });

  const afterGetUserInfo = (data, isLoading) => {
    if (!isLoading) {
      if (!data) {
        navigate(PATH.HOME);
      }
    }
  };

  const afterRequestOtp = (data, isLoading, dataError) => {
    if (data) {
      setOpenModalConfirm(true);
    } else {
      setStateNotifycation({
        open: true,
        title: t("error"),
        content: dataError?.errorMessage,
      });
      if (dataError?.showType === 2) {
        setCountdown(180);
        setOpenCount(true);
      }
    }
  };

  const afterUpdatePassword = (data, isLoading) => {
    if (isLoading) return;
    verifyingRef.current = false;
    // Lỗi thì middleware gọi callback(null, false, res) -> data là null
    if (data?.success) {
      setOpenSuccess(true);
      setOpenModalConfirm(false);
      setOpenError(false);
      setOpenCount(false);
      setPassword("");
      setConfirmPassword("");
    } else {
      setOpenError(true);
      setOpenModalConfirm(false);
      setOpenSuccess(false);
      setOpenCount(false);
    }
  };

  const afterVerifyOtp = (data, isLoading, dataError) => {
    if (isLoading) return;
    if (data) {
      const body = {
        newPassword: password,
        confirmNewPassword: confirmPassword,
        callback: afterUpdatePassword,
      };
      dispatch(updatePassword(body));
    } else {
      verifyingRef.current = false;
      setStateNotifycation({
        open: true,
        title: t("error"),
        content: dataError?.errorMessage,
      });
    }
  };

  useEffect(() => {
    if (!selectorAccount.userInfo) {
      dispatch(getCurrentUser({ callback: afterGetUserInfo }));
    }
  }, []);

  const handleChangePassword = () => {
    const errors = {
      password: "",
      confirmPassword: "",
    };

    if (!password.trim()) {
      errors.password = "error";
    }

    if (!confirmPassword.trim()) {
      errors.confirmPassword = "error";
    }

    setStatusInput(errors);

    if (errors.password || errors.confirmPassword) {
      return;
    }

    if (password !== confirmPassword) {
      setStateNotifycation({
        open: true,
        title: t("error"),
        content: t("account_page.change_password_page.passwordError"),
      });
      return;
    }
    let regex = new RegExp(
      "^(?=.*[A-Za-z])(?=.*\\d)(?=.*[@$!%#?&])[A-Za-z\\d@$!%*#?&]{12,20}$",
    );

    let found = regex.test(password);

    if (!found) {
      setStateNotifycation({
        open: true,
        title: t("error"),
        content: t('password_requirements_not_met'),
      });
      return;
    }
    setOpenCount(true);
    const body = {
      newPassword: password,
      confirmNewPassword: confirmPassword,
      isdn: selectorAccount.userInfo.isdn,
      callback: afterRequestOtp,
    };
    dispatch(requestOtp(body));
  };

  const handleConfirmOtp = (otp) => {
    if (verifyingRef.current) return;
    verifyingRef.current = true;
    const body = {
      isdnOtp: selectorAccount.userInfo.isdn,
      otp,
      callback: afterVerifyOtp,
    };
    dispatch(verifyOtpPassword(body));
  };

  useEffect(() => {
    setOtp("");
  }, [openModalConfirm]);

  return (
    <UseResponsive background="linear-gradient(rgb(252, 238, 210) 0%, rgb(253, 210, 156) 100%)">
      <div
        className="relative min-h-[100dvh] size-full"
        style={{
          backgroundImage:
            "linear-gradient(rgb(252, 238, 210) 0%, rgb(253, 210, 156) 100%), linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%)",
        }}
      >
        {/* Background */}
        <div aria-hidden className="absolute inset-0 pointer-events-none z-0">
          <img
            alt=""
            className="absolute max-w-none object-cover size-full"
            src={backgroundHeaderHistory}
          />
        </div>

        <div className="relative z-10 px-[12px]">
          <div
            className="pt-26">
            <Headers title={t("account_page.change_password")} />
          </div>
          <div
            className="flex 
									w-full
									pt-7
									sm:pt-4
									md:pt-4
									lg:pt-22
									xl:pt-22
									pb-3
									"
          >
            <div
              className="flex flex-col w-full px-[6%]"
            >
              <PasswordInput
                label={t("account_page.change_password_page.new_password")}
                placeholder={t(
                  "account_page.change_password_page.new_password",
                )}
                onChange={(e) => {
                  setStatusInput({ ...statusInput, password: "" });
                  setPassword(e.target.value);
                }}
                value={password}
              />
              <PasswordInput
                label={t("account_page.change_password_page.confirm_new_password")}
                placeholder={t("account_page.change_password_page.placeholder_confirm_new_password")}
                onChange={(e) => {
                  setStatusInput({ ...statusInput, confirmPassword: "" });
                  setConfirmPassword(e.target.value);
                }}
                value={confirmPassword}
              />
              <p className="text-center text-[22px] pt-4 text-[#f83535]">
                {stateNotifycation.content}
              </p>
              <Buttons
                classItem={`${openCount && "cursor-not-allowed opacity-50 pointer-events-none"}`}
                handleClick={handleChangePassword}
                textBtn={t("account_page.change_password")}
              />
            </div>
          </div>
          <div>
            <p className="pt-3 px-[6%]">
              <span className="text-[25px] font-medium text-[#FF383C] italic">
                {t("account_page.change_password_page.note")}:{" "}
              </span>
              <span className="text-[25px] font-medium text-[#854A0E]">
                {t("account_page.change_password_page.text_note")}
              </span>
            </p>
          </div>

          {/* popup show Confirm OTP */}
          <PopupFrame
            open={openModalConfirm}
            // open={true}
            onOpenChange={setOpenModalConfirm}
            title={t("modal.modal_login.title_confirm_otp")}
          >
            <div className="flex flex-col justify-center items-center pt-5 sm:py-7">
              <div className="text-[15px] sm:text-[20px] text-center text-[rgba(161,92,7,1)]">
                {t("modal.modal_login.text_confirm_otp").replace(
                  "_PHONE_",
                  selectorAccount?.userInfo?.isdn,
                )}
              </div>
              <div className="pt-5 text-center">
                {/* <div className="">{t("modal.modal_login.enter_otp")}</div> */}
                <div className="py-5 flex justify-center">
                  <OTPInput
                    value={otp}
                    onChange={(value) => {
                      setOtp(value);
                      // Nhập đủ 6 số -> tự xác nhận OTP + đổi mật khẩu, không cần bấm Confirm
                      if (value.length === 6) handleConfirmOtp(value);
                    }}
                    numInputs={6}
                    renderInput={(props) => (
                      <input
                        {...props}
                        className="
											!w-10 sm:!w-14
										!h-10 sm:!h-14
										mx-1
										rounded-xl
										sm:rounded-2xl
										border-1
										border-[rgba(247,178,122,1)]
										bg-[#f9dbaf]
										text-center
										text-2xl
										font-bold
										text-[#713b12]
										outline-none
										focus:border-orange-500
										focus:ring-2
										focus:ring-orange-300
									"
                      />
                    )}
                  />
                </div>
                <div className="text-[rgba(161,92,7,1)] text-[15px] sm:text-[20px]">
                  {t("modal.modal_login.resend_otp")}{" "}
                  <span
                    onClick={openCount ? null : handleChangePassword}
                    className={`${openCount ? "cursor-not-allowed opacity-50 pointer-events-none" : "text-[rgba(161,92,7,1)] cursor-pointer"}`}
                  >
                    {t("modal.modal_login.resend")}
                  </span>
                  {" "}
                  {openCount && (
                    <>
                      (
                      <Countdown
                        num={countdown}
                        onStatusChange={(status) => {
                          if (status.isFinished) {
                            setOpenCount(false);
                            setStateNotifycation({
                              open: false,
                              title: "",
                              content: "",
                            });
                          }
                        }}
                      />
                      )
                    </>
                  )}
                </div>
                <p className="text-center pt-4 text-[#f83535]">
                  {stateNotifycation.content}{" "}
                </p>
              </div>
            </div>
            <div className="sm:px-10">
              <Buttons
                handleClick={() => handleConfirmOtp(otp)}
                textBtn={t("modal.modal_login.confirm")}
                classbuttom='text-[17px] sm:text-[24px]'
              />
            </div>
          </PopupFrame>

          {/* popup ChangePassword thành công */}
          <PopupFrame
            open={openSuccess}
            onOpenChange={setOpenSuccess}
            title={t("account_page.change_password_page.successfully")}
          >
            <div className="flex flex-col justify-center items-center py-6">
              <img
                src={passwordResetImg}
                alt="password-reset"
                className="w-[47%]"
              />
              <p className="text-[rgba(161,92,7,1)] font-medium text-[15px] sm:text-[20px] pt-5">
                {t("account_page.change_password_page.your_password_has_been_successfully_updated")}
              </p>
              <div className="px-[10%]">
                <Buttons
                  handleClick={() => setOpenSuccess(false)}
                  textBtn={t("account_page.change_password_page.ok")}
                />
              </div>
            </div>
          </PopupFrame>

          {/* popup ChangePassword lỗi */}
          <PopupFrame
            // open={true}
            open={openError}
            onOpenChange={setOpenError}
            title={t("account_page.change_password_page.failed")}
          >
            <div className="flex flex-col justify-center items-center py-6">
              <img
                src={failedImg}
                alt="password-reset"
                className="w-[47%]"
              />
              <p className="text-[rgba(161,92,7,1)] font-medium text-[15px] sm:text-[20px] pt-5 text-center sm:px-20">
                {t("account_page.change_password_page.unable_to_change_your_password_please_check_your_information_and_try_again")}
              </p>
              <div className="px-[10%]">
                <Buttons
                  handleClick={() => setOpenError(false)}
                  textBtn={t("account_page.change_password_page.ok")}
                />
              </div>
            </div>
          </PopupFrame>
        </div>
      </div>
    </UseResponsive>
  );
}

export default ChangePassword;
